import { connect } from 'react-redux'
import { PuzzleHome } from '../components'

const mapStateToProps = (state) => {
  const { width } = state.window
  return ({
    windowWidth: width,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzleHome)


// WEBPACK FOOTER //
// ./src/Pages/Puzzle/containers/PuzzleHome.js